module.exports = __webpack_public_path__ + "static/logo-dark-291c83a28f8ddaf9599512c11c13b97b.png";